import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd4e9c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bookMenusAffix" }
const _hoisted_2 = ["textContent"]

import { reactive, ref, computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  BooksScrollMenu,
  BooksScrollMenuItem,
  langType,
  BooksScrollMenuType,
} from "@/types/help";
import BooksScrollMenuInfo from "./BooksScrollMenuInfo";

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTmp',
  props: {
  lang: {
    type: String,
    default: "zh",
  },
  type: {
    type: String,
    default: "web-use",
  },
},
  setup(__props) {

const props = __props


const activeName = ref("");

const resetActiveName = () => {
  activeName.value =
    (route.params.position as string) || activeData.value[0].id;
};
const activeData = computed(
  () => mainData[props.lang as langType][props.type as BooksScrollMenuType]
);
const mainData = reactive<BooksScrollMenu>(BooksScrollMenuInfo);
const router = useRouter();
const route = useRoute();
const handlerTabClick = (pane: { props: { name: string } }): void => {
  router
    .push({
      name: "helpBooks",
      params: {
        position: pane.props.name,
      },
    })
    .then(() => {
      // resetActiveName();
      // handlerScroll(pane.props.name);
    });
};
const handlerScroll = (): void => {
  let activeId = "";
  activeData.value.forEach((item: BooksScrollMenuItem, index: number) => {
    let winScrollTop = document.documentElement.scrollTop + 40;
    if (document.querySelector(`#${item.id}`).offsetTop >= winScrollTop) {
      activeId = activeId || item.id;
    }
  });
  activeName.value = activeId;
};

onUnmounted(() => {
  window.removeEventListener("scroll", handlerScroll);
});
onMounted(() => {
  resetActiveName();
  window.addEventListener("scroll", handlerScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 120 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          "tab-position": "right",
          class: "bookMenusTabs",
          onTabClick: handlerTabClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeData), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                name: item.id,
                class: _normalizeClass({ child: item.isChild || false }),
                key: index
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_tooltip, {
                    content: item.label,
                    "hide-after": 0,
                    enterable: false
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", {
                        textContent: _toDisplayString(item.label),
                        class: _normalizeClass(["txt", { 'menu-child': item.isChild }])
                      }, null, 10, _hoisted_2), [
                        [_directive_scroll_to, '#' + item.id]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]),
                _: 2
              }, 1032, ["name", "class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})